export default "__VITE_ASSET__Banq_vMm__"